import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { dismissScreenshotNotice, isScreenshotNoticeVisible, onScreenshotNotice } from '@/lib/screenGuard';

/**
 * Предупреждение после снимка экрана в iOS-приложении (D62, 26.09.2026) — правила в `lib/screenGuard.ts`.
 * Смонтировано один раз в `main.tsx`, рядом с `NetworkToast` и с тем же местом на экране (над нижним меню).
 * ⚠️ `translate="no"`, текст только внутри `<span>` — от переводчика браузера (техдолг 263).
 */
export function ScreenshotToast() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(isScreenshotNoticeVisible);

  useEffect(() => onScreenshotNotice(setVisible), []);

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      translate="no"
      data-native-video-cover=""
      className="pointer-events-none fixed inset-x-0 bottom-[calc(4.75rem_+_var(--sa-bottom))] z-50 flex justify-center px-4 md:bottom-6"
    >
      <div className="pointer-events-auto flex max-w-md items-center gap-3 rounded-2xl bg-inverse-surface py-3 pl-4 pr-2 text-sm font-medium text-inverse-on-surface shadow-lg">
        <span className="material-symbols-outlined text-lg" aria-hidden="true">lock</span>
        <span>{t('screenGuard.screenshotWarning')}</span>
        <button
          type="button"
          onClick={dismissScreenshotNotice}
          aria-label={t('common.close')}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full opacity-80 hover:opacity-100"
        >
          <span className="material-symbols-outlined text-lg" aria-hidden="true">close</span>
        </button>
      </div>
    </div>
  );
}
